export const APP_CONFIG = {
  WEBSITE: "tamdaoc.eu",
  CONTACT: [
    { locale: "en", pageId: "88" },
    { locale: "vi", pageId: "87" },
    { locale: "cs", pageId: "89" },
  ],
  ABOUT_US: [
    { locale: "en", pageId: "84" },
    { locale: "vi", pageId: "40" },
    { locale: "cs", pageId: "85" },
  ],
  RENTAL_SERVICE: [
    { locale: "en", pageId: "41" },
    { locale: "vi", pageId: "42" },
    { locale: "cs", pageId: "86" },
  ],
  HOME_PAGE_ID: [
    { locale: "en", pageId: "38" },
    { locale: "vi", pageId: "39" },
    { locale: "cs", pageId: "83" },
  ],
  SALE_PROMOTION_PAGE_ID: [
    { locale: "en", pageId: "23" },
    { locale: "vi", pageId: "53" },
    { locale: "cs", pageId: "54" },
  ],
  INFO_SERVICES_PAGE_ID: [
    { locale: "en", pageId: "26" },
    { locale: "vi", pageId: "55" },
    { locale: "cs", pageId: "56" },
  ],
  OUR_STORES_PAGE_ID: [
    { locale: "en", pageId: "27" },
    { locale: "vi", pageId: "44" },
    { locale: "cs", pageId: "43" },
  ],
  FOR_SUPPLIER_PAGE_ID: [
    { locale: "en", pageId: "25" },
    { locale: "vi", pageId: "59" },
    { locale: "cs", pageId: "60" },
  ],
  NEWS_PAGE_ID: [
    { locale: "en", pageId: "24" },
    { locale: "vi", pageId: "45" },
    { locale: "cs", pageId: "46" },
  ],

  // Categories
  PROMOTION_CATEGORIES: [
    { locale: "en", categoryId: "6" },
    { locale: "vi", categoryId: "43" },
    { locale: "cs", categoryId: "8" },
  ],
  HOW_TO_COOK_CATEGORIES: [
    { locale: "en", categoryId: "9" },
    { locale: "vi", categoryId: "40" },
    { locale: "cs", categoryId: "41" },
  ],
  KEEP_IN_TOUCH_CATEGORIES: [
    { locale: "en", categoryId: "37" },
    { locale: "vi", categoryId: "38" },
    { locale: "cs", categoryId: "39" },
  ],

  STATIC_PAGES: {
    COMPLAINTS_AND_INQUIRIES: [
      { locale: "en", pageId: "28" },
      { locale: "vi", pageId: "57" },
      { locale: "cs", pageId: "58" },
    ],
    PRIVACY: [
      { locale: "en", pageId: "29" },
      { locale: "vi", pageId: "51" },
      { locale: "cs", pageId: "52" },
    ],
    PROVISION: [
      { locale: "en", pageId: "62" },
      { locale: "vi", pageId: "61" },
      { locale: "cs", pageId: "63" },
    ],
    GDPR: [
      { locale: "en", pageId: "65" },
      { locale: "vi", pageId: "64" },
      { locale: "cs", pageId: "66" },
    ],
    WHY_US: [
      { locale: "en", pageId: "68" },
      { locale: "vi", pageId: "67" },
      { locale: "cs", pageId: "69" },
    ],
    CONTACT: [
      { locale: "en", pageId: "71" },
      { locale: "vi", pageId: "70" },
      { locale: "cs", pageId: "72" },
    ],
  },

  CONTACT_US: [
    { locale: "en", pageId: "5" },
    { locale: "vi", pageId: "6" },
    { locale: "cs", pageId: "9" },
  ],
}
